export default "__VITE_ASSET__DErh$mie__"